/*!

=========================================================
* Argon Dashboard React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
/*eslint-disable*/
import React, { useState, useContext, useEffect } from "react";
import { NavLink as NavLinkRRD, Link } from "react-router-dom";
// nodejs library to set properties for components
import { PropTypes } from "prop-types";
import { UserType } from "../../context/UserType";
import DesignServicesIcon from "@mui/icons-material/DesignServices";
import TextField from "@mui/material/TextField";
import UserService from "../Users/UserService";
import moment from "moment";
// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Collapse,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Media,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Progress,
  Table,
  Container,
  Row,
  Col,
} from "reactstrap";

const Sidebar = (props) => {
  const [tester, setTester] = useState(null);
  const [testerState, setTesterState] = useState(false);
  const [idUser, setIdUser] = useState(() => {
    const idUserStoraged = localStorage.getItem("TOKEN_ID_USER");
    if (idUserStoraged) {
      return idUserStoraged;
    }
    return;
  });
  const [image, setImage] = useState("");
  const [collapseOpen, setCollapseOpen] = useState();
  const { userType } = useContext(UserType);
  useEffect(() => {
    UserService.getUserById(idUser).then((response) => {
      const data = response.data;
      if (data.type === "Tester") {
        const createdAt = moment(data.createdAt).format("YYYY-MM-DD");
        const dateNow = moment(new Date()).format("YYYY-MM-DD");
        const compare = moment(dateNow).diff(moment(createdAt));
        const resultCompare = moment.duration(compare).asDays();
        setTester(30 - resultCompare);
        setTesterState(true);
      }
      setImage(data.foto);
    });
  }, []);
  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    return props.location.pathname.indexOf(routeName) > -1 ? "active" : "";
  };
  // toggles collapse between opened and closed (true/false)
  const toggleCollapse = () => {
    setCollapseOpen((data) => !data);
  };
  // closes the collapse
  const closeCollapse = () => {
    setCollapseOpen(false);
  };

  // creates the links that appear in the left menu / Sidebar
  const createLinks = (routes) => {
    return routes.map((prop, key) => {
      if (
        (userType === "Administrador" || userType === "Corpo Técnico") &&
        prop.path !== "/qrcode" &&
        prop.path !== "/profile" &&
        prop.path !== "/calendar" &&
        prop.path !== "/report"
      ) {
        return (
          <NavItem key={key}>
            <NavLink
              to={prop.layout + prop.path}
              tag={NavLinkRRD}
              onClick={closeCollapse}
              activeClassName="active"
            >
              {prop.icon === "Fornecedor" ? (
                <DesignServicesIcon
                  style={{
                    color: "#FF2828",
                    marginRight: "0.7em",
                    marginLeft: "-0.2em",
                  }}
                />
              ) : (
                <i className={prop.icon} />
              )}
              {prop.name}
            </NavLink>
          </NavItem>
        );
      } else if (prop.path === "/spares" || prop.path === "/management") {
        if (userType === "Amoxarife e Ferramenteiro") {
          return (
            <NavItem key={key}>
              <NavLink
                to={prop.layout + prop.path}
                tag={NavLinkRRD}
                onClick={closeCollapse}
                activeClassName="active"
              >
                {prop.icon === "Fornecedor" ? (
                  <DesignServicesIcon
                    style={{
                      color: "#FF2828",
                      marginRight: "0.7em",
                      marginLeft: "-0.2em",
                    }}
                  />
                ) : (
                  <i className={prop.icon} />
                )}
                {prop.name}
              </NavLink>
            </NavItem>
          );
        } else if (userType === "Amoxarife" && prop.path === "/spares") {
          return (
            <NavItem key={key}>
              <NavLink
                to={prop.layout + prop.path}
                tag={NavLinkRRD}
                onClick={closeCollapse}
                activeClassName="active"
              >
                {prop.icon === "Fornecedor" ? (
                  <DesignServicesIcon
                    style={{
                      color: "#FF2828",
                      marginRight: "0.7em",
                      marginLeft: "-0.2em",
                    }}
                  />
                ) : (
                  <i className={prop.icon} />
                )}
                {prop.name}
              </NavLink>
            </NavItem>
          );
        } else if (
          prop.path === "/management" &&
          userType === "Ferramenteiro"
        ) {
          return (
            <NavItem key={key}>
              <NavLink
                to={prop.layout + prop.path}
                tag={NavLinkRRD}
                onClick={closeCollapse}
                activeClassName="active"
              >
                {prop.icon === "Fornecedor" ? (
                  <DesignServicesIcon
                    style={{
                      color: "#FF2828",
                      marginRight: "0.7em",
                      marginLeft: "-0.2em",
                    }}
                  />
                ) : (
                  <i className={prop.icon} />
                )}
                {prop.name}
              </NavLink>
            </NavItem>
          );
        }
      } else if (
        prop.path !== "/management" &&
        prop.path !== "/qrcode" &&
        prop.path !== "/profile" &&
        prop.path !== "/calendar" &&
        prop.path !== "/strategy" &&
        prop.path !== "/report"
      ) {
        if (
          prop.path !== "/index" &&
          userType === "Requisitante" &&
          prop.path !== "/fornecedores" &&
          prop.path !== "/performer"
        ) {
          return (
            <NavItem key={key}>
              <NavLink
                to={prop.layout + prop.path}
                tag={NavLinkRRD}
                onClick={closeCollapse}
                activeClassName="active"
              >
                <i className={prop.icon} />
                {prop.name}
              </NavLink>
            </NavItem>
          );
        }
        if (
          prop.path !== "/index" &&
          userType === "Executante" &&
          prop.path !== "/fornecedores"
        ) {
          return (
            <NavItem key={key}>
              <NavLink
                to={prop.layout + prop.path}
                tag={NavLinkRRD}
                onClick={closeCollapse}
                activeClassName="active"
              >
                <i className={prop.icon} />
                {prop.name}
              </NavLink>
            </NavItem>
          );
        }
      }
    });
  };

  const { bgColor, routes, logo } = props;
  let navbarBrandProps;
  if (logo && logo.innerLink) {
    navbarBrandProps = {
      to: logo.innerLink,
      tag: Link,
    };
  } else if (logo && logo.outterLink) {
    navbarBrandProps = {
      href: logo.outterLink,
      target: "_blank",
    };
  }

  return (
    <Navbar
      className="navbar-vertical fixed-left navbar-light bg-white"
      expand="md"
      id="sidenav-main"
    >
      <Container fluid>
        {/* Toggler */}
        <button
          className="navbar-toggler"
          type="button"
          onClick={toggleCollapse}
        >
          <span className="navbar-toggler-icon" />
        </button>
        {/* Brand */}
        {logo ? (
          <NavbarBrand className="pt-0" {...navbarBrandProps}>
            <img
              alt={logo.imgAlt}
              className="navbar-brand-img"
              src={logo.imgSrc}
            />
          </NavbarBrand>
        ) : null}
        {/* User */}
        <Nav className="align-items-center d-md-none">
          <UncontrolledDropdown nav>
            <DropdownToggle nav className="nav-link-icon">
              <i className="ni ni-bell-55" />
            </DropdownToggle>
            <DropdownMenu
              aria-labelledby="navbar-default_dropdown_1"
              className="dropdown-menu-arrow"
              right
            >
              <DropdownItem>Action</DropdownItem>
              <DropdownItem>Another action</DropdownItem>
              <DropdownItem divider />
              <DropdownItem>Something else here</DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
          <UncontrolledDropdown nav>
            <DropdownToggle nav>
              <Media className="align-items-center">
                <span className="avatar avatar-sm rounded-circle">
                  {image && (
                    <img
                      alt="..."
                      src={image} //colocar aqui a imagem
                    />
                  )}
                </span>
              </Media>
            </DropdownToggle>
            <DropdownMenu className="dropdown-menu-arrow" right>
              <DropdownItem className="noti-title" header tag="div">
                <h6 className="text-overflow m-0">Welcome!</h6>
              </DropdownItem>
              <DropdownItem to="/admin/user-profile" tag={Link}>
                <i className="ni ni-single-02" />
                <span>Meu perfil</span>
              </DropdownItem>
              <DropdownItem to="/admin/user-profile" tag={Link}>
                <i className="ni ni-settings-gear-65" />
                <span>Configurações</span>
              </DropdownItem>
              <DropdownItem to="/admin/user-profile" tag={Link}>
                <i className="ni ni-calendar-grid-58" />
                <span>Atividadesx</span>
              </DropdownItem>
              <DropdownItem to="/admin/user-profile" tag={Link}>
                <i className="ni ni-support-16" />
                <span>Suporta</span>
              </DropdownItem>
              <DropdownItem divider />
              <DropdownItem onClick={(e) => e.preventDefault()}>
                <i className="ni ni-user-run" />
                <span>Sair</span>
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </Nav>
        {/* Collapse */}
        <Collapse navbar isOpen={collapseOpen}>
          {/* Collapse header */}
          <div className="navbar-collapse-header d-md-none">
            <Row>
              {logo ? (
                <Col className="collapse-brand" xs="6">
                  {logo.innerLink ? (
                    <Link to={logo.innerLink}>
                      <img alt={logo.imgAlt} src={logo.imgSrc} />
                    </Link>
                  ) : (
                    <a href={logo.outterLink}>
                      <img alt={logo.imgAlt} src={logo.imgSrc} />
                    </a>
                  )}
                </Col>
              ) : null}
              <Col className="collapse-close" xs="6">
                <button
                  className="navbar-toggler"
                  type="button"
                  onClick={toggleCollapse}
                >
                  <span />
                  <span />
                </button>
              </Col>
            </Row>
          </div>
          {/* Form */}
          <Form className="mt-4 mb-3 d-md-none">
            <InputGroup className="input-group-rounded input-group-merge">
              <Input
                aria-label="Search"
                className="form-control-rounded form-control-prepended"
                placeholder="Search"
                type="search"
              />
              <InputGroupAddon addonType="prepend">
                <InputGroupText>
                  <span className="fa fa-search" />
                </InputGroupText>
              </InputGroupAddon>
            </InputGroup>
          </Form>
          {/* Navigation */}
          {testerState && (
            <TextField
              id="standard-basic"
              variant="standard"
              disabled={true}
              style={{ marginBottom: "1em" }}
              value={"Expira em " + tester + " dias"}
            />
          )}
          <Nav navbar>{createLinks(routes)}</Nav>
        </Collapse>
      </Container>
    </Navbar>
  );
};

Sidebar.defaultProps = {
  routes: [{}],
};

Sidebar.propTypes = {
  // links that will be displayed inside the component
  routes: PropTypes.arrayOf(PropTypes.object),
  logo: PropTypes.shape({
    // innerLink is for links that will direct the user within the app
    // it will be rendered as <Link to="...">...</Link> tag
    innerLink: PropTypes.string,
    // outterLink is for links that will direct the user outside the app
    // it will be rendered as simple <a href="...">...</a> tag
    outterLink: PropTypes.string,
    // the image src of the logo
    imgSrc: PropTypes.string.isRequired,
    // the alt for the img
    imgAlt: PropTypes.string.isRequired,
  }),
};

export default Sidebar;
